import { CSSProperties, FC, HTMLAttributes } from 'react';

interface Props {
    bg?: string;
    styles?: CSSProperties;
}

export const Row: FC<Props & HTMLAttributes<HTMLDivElement>> = ({ bg = 'white', styles, children, ...props }) => (
    <div
        style={{
            ...styles,
            display: 'flex',
            width: '100%',
            background: bg,
        }}
        {...props}
    >
        {children}
    </div>
);
